import { render, staticRenderFns } from "./GreyBoxForm.vue?vue&type=template&id=0ea314a6"
import script from "./GreyBoxForm.vue?vue&type=script&lang=ts"
export * from "./GreyBoxForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports